import gql from 'graphql-tag';

export default gql`
mutation skipRedirect($obj: SkipRedirectInput!) {
  skipRedirect(object: $obj) {
    affected_rows
  }
}
`;
